import { render, staticRenderFns } from "./SettingsSystem.vue?vue&type=template&id=5e8acc92&scoped=true"
import script from "./SettingsSystem.vue?vue&type=script&lang=js"
export * from "./SettingsSystem.vue?vue&type=script&lang=js"
import style0 from "./SettingsSystem.vue?vue&type=style&index=0&id=5e8acc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8acc92",
  null
  
)

export default component.exports